import { ApiService } from '../../../types/api';
import type { Discount } from '../types';
import { DiscountApi, type DiscountApiContract } from './discount.api';

export interface DiscountsApiContract {
  discount(id: string): DiscountApiContract;

  list(): Promise<Discount[]>;
}

declare module '../../../context/page-context' {
  interface Apis {
    discounts: DiscountsApiContract;
  }
}

export class DiscountsApi extends ApiService implements DiscountsApiContract {
  public discount(id: string): DiscountApiContract {
    return new DiscountApi(this.api, id);
  }

  public list(): Promise<Discount[]> {
    return this.api.proxy<Discount[]>({
      method: 'GET',
      path: '/v1/discounts',
      payload: {},
    });
  }
}
